import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isShowGeoJSONSelector, toggleShowGeoJSON } from './mapSlice';

export default function useMapShowGeoJSON() {
  const dispatch = useDispatch();
  const isShowGeoJSON = useSelector(isShowGeoJSONSelector);

  const toggle = React.useCallback(() => {
    dispatch(toggleShowGeoJSON());
  }, [dispatch]);

  return {
    isShowGeoJSON,
    toggle,
  };
}
